import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Box, Radio } from "@mui/material";
import PropTypes from "prop-types";
import SettingsOption from "../SettingsOption";

const useStyles = makeStyles(theme => ({
  radioButton: {
    margin: theme.spacing(0, 7.75),
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(0, 3)
    },
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(-0.5, 1, 0, 1)
    }
  }
}));

function LogoSettingsOption(props) {
  const { checked, onLogoSettingChanged, label, children } = props;
  const classes = useStyles();

  return (
    <SettingsOption highlighted={checked}>
      <Box
        display="flex"
        pt={4}
        pb={{ xs: 1, md: 4 }}
        alignItems={{ xs: "flex-start", sm: "center" }}
      >
        <Radio
          color="primary"
          checked={checked}
          onChange={onLogoSettingChanged}
          value={label}
          classes={{ root: classes.radioButton }}
          inputProps={{ "aria-label": label }}
        />
        <Box display="flex" flexDirection="column">
          {children}
        </Box>
      </Box>
    </SettingsOption>
  );
}

export default LogoSettingsOption;

LogoSettingsOption.propTypes = {
  label: PropTypes.string,
  handleChange: PropTypes.func,
  checked: PropTypes.bool,
  children: PropTypes.node
};
